var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSupportFilled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    color: "#FF9900",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.398438 6.18478C0.398438 9.30478 2.92494 11.8318 6.04426 11.8318C9.16357 11.8318 11.6901 9.30478 11.6901 6.18478C11.6901 3.06478 9.16357 0.53772 6.04426 0.53772C2.92494 0.53772 0.398438 3.06478 0.398438 6.18478ZM5 3.99995C5 3.44767 5.44772 2.99995 6 2.99995C6.55228 2.99995 7 3.44767 7 3.99995V4.99995H8C8.55229 4.99995 9 5.44767 9 5.99995C9 6.55224 8.55229 6.99995 8 6.99995H7V7.99995C7 8.55223 6.55228 8.99995 6 8.99995C5.44772 8.99995 5 8.55223 5 7.99995V6.99995H4C3.44772 6.99995 3 6.55224 3 5.99995C3 5.44767 3.44772 4.99995 4 4.99995H5V3.99995Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportFilled);
export default __webpack_public_path__ + "static/media/support-filled.2ab5ea9d.svg";
export { ForwardRef as ReactComponent };